import React from 'react'
import About from '../Pages/About'
import Gym from '../Pages/Gym'
import Contact from '../Pages/Contact'
import Footer from './Footer'

export default function Main() {
  return (
    <div>
        <About/>
        <Gym/>
        <Contact/>
        <Footer/>
    </div>
  )
}
